import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../actions';
import './MoreOptions.scss';
import { push } from 'redux-first-history';
/**
 * MoreOptions Component
 */
export class MoreOptions extends Component {
  /**
   * The allowed properties for the MoreOptions component
   * @param {function} onMoreOptions What should happen when the user clicks the "More Options" button
   * @param {function} changeModality change the current modality being used for auth/enroll
   * @param {string} currentModality the current modality being used for auth/enroll
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    onMoreOptions: PropTypes.func,
    changeModality: PropTypes.func,
    currentModality: PropTypes.oneOf([
      'sms',
      'otp',
      'iid',
      'tempcode',
      'password',
      'pin',
    ]),
    availableModalities: PropTypes.arrayOf(PropTypes.string),
  };

  render() {
    const moreOptionsElement =
      (
        <button id='btnChooseModality'
          className='btn btn-link text-center More-Options'
          onClick={this.props.startChooseModality}>
              Use another login method
        </button>
      );

    return moreOptionsElement;
  }
}


const mapStateToProps = state => {
  const { availableModalities, serverState, } = state.login;
  return {
    availableModalities,
    serverState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeModality: (fromModality, toModality) => {
      dispatch(actions.changeModality(fromModality, toModality) );
    },
    startChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MoreOptions);
